<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>用户信息</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>

<script>
	export default {}
</script>

<style></style>
